import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { Link } from '@domain-group/suit-theme'

import useInvoiceItem from '@hooks/useInvoiceItem'

import type { InvoiceItemModel, InvoiceModel } from '@models/types'

interface InvoiceItemActionProps {
  invoice: InvoiceModel,
  invoiceItem: InvoiceItemModel,
}

const InvoiceItemAction = (props: InvoiceItemActionProps) => {
  const { invoice, invoiceItem } = props

  const invoiceItemPayload = useInvoiceItem(invoiceItem)
  const {
    callbacks: {
      createOrEditInvoiceItem,
    },
  } = invoiceItemPayload

  const invoiceApproved = invoice?.approved
  const invoiceVoided = invoice?.void

  const shouldHideActionItems = !invoiceItem?.id || invoiceApproved || invoiceVoided

  if (shouldHideActionItems) return null

  return (
    <Link greyLink onClick={() => createOrEditInvoiceItem()}>
      <FontAwesomeIcon icon={faPencil} />
    </Link>
  )
}

export default InvoiceItemAction
